'use strict';
module.exports = require('./Toast.vue');